// De modular Auth-API, voor wat de compat-laag niet kan: MFA met een
// authenticator-app (TOTP). Nodig omdat `auth` uit config.js de compat-instantie
// is, en `multiFactor`, `TotpMultiFactorGenerator` en `getMultiFactorResolver`
// alleen in de modular API bestaan en een modular `Auth`/`User` verwachten.
//
// Het is DEZELFDE instantie als de compat-laag gebruikt (modularAuth.test.js
// bewijst dat), mits config.js eerst geladen is: compat initialiseert Auth met
// de persistentie waarop gebruikers al ingelogd zijn. Roep je `getAuth()` eerder
// aan, dan initialiseert de modular API hem zelf met een andere instelling.
// Vandaar de import hieronder, en vandaar dat fase 4 `getAuth` niet rechtstreeks
// uit 'firebase/auth' haalt maar via dit bestand.
//
// AI-CONTEXT: See docs/features/mfa-totp.md
import {
    getAuth,
    multiFactor,
    TotpMultiFactorGenerator,
    getMultiFactorResolver,
    reauthenticateWithCredential,
    EmailAuthProvider,
} from 'firebase/auth'
import './config'

/**
 * @returns {import('firebase/auth').Auth} De modular Auth van de app; `currentUser` is de ingelogde gebruiker
 */
const getModularAuth = () => getAuth()

export {
    getModularAuth,
    multiFactor,
    TotpMultiFactorGenerator,
    getMultiFactorResolver,
    // Koppelen en ontkoppelen eisen een recente inlog.
    reauthenticateWithCredential,
    EmailAuthProvider,
}
